<template>
  <div id="app">
    <Layout>
      <router-view/>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/layouts/Layout.vue'

export default {
  name: 'App',

  components: {
    Layout
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
}

html,
body {
  height: 100%;
}

body {
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  margin: 0;
  padding: 0;
  background: #000000;

  .footer{
    padding-top: 64px;
    border-top:1px solid rgba(255, 255, 255, 0.1);

  }

  .footer{
    padding-top: 64px;
    border-top:1px solid rgba(255, 255, 255, 0.1);

  }

  .footer-wrapper {
    flex-direction: column;
    align-items: center;
    margin: 0;
    max-width: 1680px;
  }

  .footer_form_input {
    background: #FFFFFF14;
    padding: 12px 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 0px 0px #FFFFFF1A inset;
    border: none;
    color: #999999;
    width: 65%;
  }

  .footer_form {
    margin-bottom: 48px;
  }

  .footer_form_btn {
    padding: 12px 10px;
    border-radius: 10px;
    border: none;
    margin-left: 12px;
    cursor: pointer;
    font-weight: 500;
  }

  .footer-col-title {
    font-size: 16px !important;
    font-weight: 500;
    line-height: 24px;
    color: #FCFCFD;
    padding-bottom: 16px;
  }

  .footer-col-text {
    font-size: 14px !important;
    font-weight: 400;
    line-height: 16px;
    color: #9EA3AE;
    padding-bottom: 10px;
  }

  @media (max-width: 200px) {
    .footer-col-text {
      width: 10%;
    }
  }

  #app {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .footer-wrapper {
    position: relative;
    padding: 0 70px 30px 70px;
    color: #D4D5D9;
    font-size: 10px;
    font-weight: 100;

    a:link {
      color: #D4D5D9;
    }

    a:visited {
      color: #D4D5D9;
    }
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
    text-align: center;

    a {
      font-size: 13px;
      line-height: 19px;
      text-decoration: none;
    }

    h4 {
      font-size: 20px;
      line-height: 26px;
      font-weight: 700;
    }

    p {
      font-size: 12px;
      line-height: 19px;
    }

    #footer_main {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      gap: 16px;
      width: 100%;
      text-align: left;
    }

    .desktop {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

    }
  }
  .text-spam{
    width: 50%;
  }

  @media screen and (max-width: 768px) {
    .text-spam{
      width: 100%;
    }

    .footer-wrapper{
      padding: 0;
    }
    .footer_form_btn{
      margin: 0;
    }
    #footer {
      flex-direction: column;
      align-items: center;

      .desktop {
        display: none;
      }

      #footer_main {
        text-align: center;
        align-items: center;
        flex-direction: column;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue